// extracted by mini-css-extract-plugin
export default {"cls1":"B0y7Wi8fUOu3QPMH1bss","cls2":"BHXgo7JuUqy4cCBIfazE B0y7Wi8fUOu3QPMH1bss"};